import helperFunctions from "./helper-functions";
import mandateModel from "@/store/orm-axios/models/Mandate";
let eventSource;

const mandateIRI = "/mandates/";

export default {
  computed: {
    mercureJwtToken() {
      return this.$store.getters["auth/mercureJwtToken"];
    },
  },
  watch: {
    mercureJwtToken(oldValue, newValue) {
      if (oldValue.length != 0 && newValue.length != 0) {
        this.initMandateMercure();
      }
    },
  },
  mounted() {
    this.initMandateMercure();
  },
  beforeDestroy() {
    eventSource.close();
  },
  methods: {
    initMandateMercure() {
      if (eventSource) eventSource.close();

      const topics = [`${mandateIRI}{id}`];

      eventSource = helperFunctions.getEventSource(topics);

      eventSource.onmessage = event => {
        const eventData = JSON.parse(event.data);

        var model = null;
        if (eventData["@id"].includes(mandateIRI)) {
          model = mandateModel;
        }
        helperFunctions.modifyInStore(eventData, model, eventData["@type"]);
      };

      helperFunctions.case401Error(eventSource);
    },
  },
};
